{
  "app_name": "Jinshuju Testing",
  "ios": {
    "CFBundleDisplayName": "Jinshuju Testing"
  }
}
